import { TileLayer } from "react-leaflet";
import { MAP_STYLES } from "./mapStyles";

/**
 * Renders the base TileLayer + optional overlay for a given map style id.
 * Must be placed inside a <MapContainer>.
 */
export default function MapTiles({ styleId = "streets" }) {
  const s = MAP_STYLES[styleId] || MAP_STYLES.streets;
  return (
    <>
      <TileLayer
        key={`base-${s.id}`}
        url={s.url}
        subdomains={s.subdomains}
        attribution={s.attribution}
        maxZoom={s.maxZoom}
      />
      {s.overlay && (
        <TileLayer
          key={`overlay-${s.id}`}
          url={s.overlay.url}
          subdomains={s.overlay.subdomains}
          opacity={s.overlay.opacity}
          maxZoom={s.overlay.maxZoom}
        />
      )}
    </>
  );
}
